/**
 * These endpoints are paths only
 * Consumers of these endpoints are responsible for adding any needed queryString
 *
 * @memberof bunsen
 * @namespace endpoints
 */

'use strict';

var ends = {};
var soa = '/soa';
var services = '/services';
var query = 'queryservice';
var json = 'json';
var usercomm = 'usercomm/1';
var usercommv3 = 'usercomm/3';
var form = 'formservice';
var cms = 'cms';
var portfolio = 'portfolio';
var portfolios = 'portfolios';
var creator = 'creator';
var boss11 = 'boss/1.1';
var userservice = 'userservice';
var item = 'itemservice';
var masqueradeSeller = 'masquerade_seller';
var Qs = require('qs');
var isArray = require('lodash.isarray');
var isEmpty = require('lodash.isempty');
var versions = require('./versions');
var latest = versions.latest;
var latestServices = versions.latestServices;

function uriJoin() {
    return Array.prototype.slice.call(arguments).join('/');
}

ends.cmsUpload = function (type, dir) {
    var args = [soa, boss11, 'upload'];

    if (type) {
        args.push(type);
    }
    if (dir) {
        args.push(dir);
    }
    return uriJoin.apply(null, args);
};

/**
 * Newer endpoint to upload images for items.
 * @returns {string|boolean}
 */
ends.itemImageUpload = function () {
    return uriJoin(soa, latest.inventoryFileUpload, 'images', 'upload');
};

ends.sellerStatuses = function () {
    return uriJoin(soa, latest.identity, 'seller', 'statuses');
};

/**
 * Endpoint to upload images. You must pass a type (e.g. "general" or "dealers")
 * NOTE: If you use this endpoint in .com, keep in mind that Array.prototype.indexOf
 * is not fully supported in IE8.
 * @param {string} type
 * @param {number} sellerId
 * @returns {string|boolean}
 * @throws Will throw an error if no `sellerId` argument is passed and `type` = 'dealers' || 'dealer_logo'
 */
ends.uploadImages = function (type, sellerId) {
    var types = ['general', 'cms', 'editorial', 'dealers', 'dealer_logo'];

    if ((types.indexOf(type)) !== -1) {
        if ((type === 'dealers' || type === 'dealer_logo')) {
            if (!sellerId) {
                throw new Error('seller Legacy Id required to create endpoint if type is "dealers"');
            }

            type = (type === 'dealers') ? 'dealer_image_upload' : 'general_image_upload/' + type;
            return '/image/ajax/' + type + '?seller_id=' + sellerId;
        }
        return '/image/ajax/general_image_upload/' + type;
    } else {
        return false;
    }
};

/**
 * Returns message contact imaging endpoint.
 * @returns {string}
 */
ends.contactImaging = function () {
    return '/old-dealer-admin/libraries/ajax/imaging_contact.php';
};

/**
 * Modify image (rotate, eventually crop).
 */
ends.processImage = function (itemId, photoId) {
    return uriJoin(ends.item(itemId), 'image', photoId, 'process');
};

/**
 * Download an image. Accepts the path to the image as a get param.
 * @param itemId
 * @param imageId
 * @param imgUrl
 * @returns {string}
 */
ends.downloadOriginal = function (itemId, imageId) {
    return uriJoin(soa, latest.inventoryFileUpload, 'image', imageId, 'download');
};

/**
 * Add, remove or reorder photos and images.
 */
ends.photos = function (itemId) {
    return uriJoin(soa, latest.inventory, 'item', itemId, 'images');
};

/**
 * Save item images (different permissions)
 */
ends.updateItemImages = function () {
    return uriJoin(services, item, 'save_item_images');
};

ends.process = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getSingleProcess = function (id) {
    return uriJoin(soa, boss11, 'process', id);
};

ends.getAllProcesses = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getProcessTypes = function () {
    return uriJoin(soa, boss11, 'process', 'types');
};

ends.messageGET = function (options) {
    console.assert(options.message, "messageGET endpoint expects an argument like {message: messageId}");
    return [soa, latest.messagecenter, 'message', options.message].join('/');
};
ends.messagePOST = function (options) {
    console.assert(options.conversation, "messagePOST endpoint expects an argument like {conversation: conversationId}");
    return [soa, latest.messagecenter, 'message', 'web', options.conversation].join('/');
};
ends.messageNewConversation = function () {
    return [soa, latest.messagecenter, 'message'].join('/');
};
ends.conversations = [soa, latestServices.messagecenter + '/2', 'conversations'].join('/');
ends.markReadUnread = [soa, latest.messagecenter, 'message', 'markReadUnread'].join('/'); //?conversationIds=201
ends.flagMessage = [soa, latest.mcFlagMessage, 'message', 'flag'].join('/');
ends.conversation = function (id, options) {
    options = options || {};
    return uriJoin(soa, latestServices.messagecenter + '/2', 'conversation', id) + (isEmpty(options.params) ? '' : '?' + Qs.stringify(options.params));
};
ends.conversationFilter = function () {
    return [soa, latestServices.messagecenter, '2', 'conversation', 'filter'].join('/');
};

ends.pushNotification = function (isBulk) {
    if (isBulk) {
        return uriJoin(soa, usercomm, 'push', 'bulk');
    }
    return uriJoin(soa, usercomm, 'push');
};

ends.dealerNotification = function (isBulk) {
    var endpoint = uriJoin(soa, latest.usercomm, 'send');
    if (isBulk) {
        endpoint = uriJoin(endpoint, 'bulk');
    }
    return endpoint;
};

ends.conversationMembers = function (ids) {
    if (undefined !== ids && !isArray(ids)) {
        ids = [ids];
    }
    return [soa, latest.messagecenter, 'member?'].join('/') + Qs.param({memberIds: ids.join(',')});
};
ends.conversationUnsubscribe = function () {
    return [soa, latest.messagecenter, 'member', 'unsubscribe'].join('/');
};
ends.note = function (id, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'note', id);
};

ends.notes = function (service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes');
};

ends.notesByAnchor = function (anchor, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes', anchor);
};

ends.address = function (id) {
    return uriJoin(soa, latest.identity, 'address', id);
};

ends.zipCode = function () {
    return uriJoin(soa, latest.identity, 'address', 'resolve', 'zip');
};

ends.addressBook = function (userId, addressType, addressId) {
    var uriArgs;
    if (!userId) {
        return false;
    }
    uriArgs = [soa, latest.identity, 'user', userId, 'addressBook'];

    if (addressType) {
        uriArgs.push(addressType);
        //nested because addressId depends on addressType being there first
        if (addressId) {
            uriArgs.push(addressId);
        }
    }

    return uriJoin.apply(this, uriArgs);
};

ends.returnPolicy = function (id) {
    return uriJoin(soa, latest.identity, 'returnPolicy', id);
};

ends.itemsReturnPolicy = function () {
    return uriJoin(soa, latest.inventoryItem, 'items', 'returnPolicy');
};

ends.sellerReturnPolicy = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'returnPolicy');
};

ends.adjustmentsForItemByType = function (itemId, type) {
    return uriJoin(soa, latest.ecom, 'adjustments', type, itemId);
};

ends.computeAdjustments = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', 'computeAdjustments');
};

ends.currencyConversion = function () {
    return uriJoin(soa, latest.ecom, 'currency', 'conversion');
};

ends.currencyConvert = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'convert');
};

ends.currentRates = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'conversionRateEvent', 'currentRates');
};

ends.feeStructure = function (feeStructureId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'anchors');
};

ends.feeStructures = function () {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructures');
};

ends.feeStructureUpdate = function (feeStructureId, sellerId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'seller', sellerId);
};

ends.savedCard = function (userId, hashedCardNumber) {
    return uriJoin(soa, latest.identity, 'user', userId, 'creditCard', hashedCardNumber);
};

/**
 * @code /services/queryservice/item_creator_shipping.dibs
 * @memberof bunsen.endpoints
 */
ends.getItemCreatorShipping = function () {
    return uriJoin(services, query, 'item_creator_shipping.dibs');
};

/**
 * @code /services/queryservice/item_creator_woc.dibs
 * get a single item json based on iid
 */
ends.getItemByIid = function () {
    return uriJoin(services, query, 'item_creator_woc.dibs');
};

ends.dealerAnnouncements = function () {
    return uriJoin(soa, query, json, 'dealer_announcement.dibs');
};
/**
 * QueryService reference_set query.
 * used to get display values for enums
 * formerly "referenceSetJSON" from adminv2
 */
ends.referenceSet = function () {
    return uriJoin(soa, query, json, 'reference_set.dibs');
};

ends.FashionCategoryToTechnique = function () {
    return uriJoin(soa, query, json, 'fashion_cat_techniques_2.dibs');
};

ends.fashionInflatedTechniques = function () {
    return uriJoin(soa, query, json, 'fashion_techniques.dibs');
};

/**
 * Get the dealer's country id based on their seller ID.
 *
 */
ends.getDealerCountryId = function () {
    return uriJoin(soa, query, json, 'seller_geo_v2.dibs');
};

ends.transactionsSolr = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transactions', 'search');
};

ends.transactionSummary = function () {
    return uriJoin(soa, latest.ecomSummary, 'transaction', 'summary');
};

ends.transaction = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction');
};

/**
 * /soa/ecom-4/transaction/[transactionId]/history
 */
ends.transactionHistory = function (id) {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', id, 'history');
};

ends.transactionDisplayCodes = function () {
    return uriJoin(ends.transaction(), 'displayCodes');
};

ends.transactionPing = function () {
    return uriJoin(ends.transaction(), 'ping');
};

ends.transactionKount = function () {
    return uriJoin(ends.transaction(), 'data.gif');
};

ends.paymentProviderClientToken = function () {
    return uriJoin(soa, latest.ecom, 'paymentProviderTransaction', 'clientToken');
};

ends.shipment = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipment', id);
};

ends.ecomShipmentQuote = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipmentQuote', id);
};
ends.shipmentQuote = function (id) {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', id);
};

ends.shipmentQuotes = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuotes');
};

ends.shippingCosts = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shippingCosts');
};

ends.computeShipmentQuoteSubTotal = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'compute');
};

ends.availableOptions = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'availableOptions');
};

/**
 * /soa/ecom-t2/2/shipmentQuote/determineRegion
 * @memberof bunsen.endpoints
 */
ends.determineRegion = function () {
    return uriJoin(soa, latest.ecom, 'shipmentQuote', 'determineRegion');
};

ends.serviceMethod = function (id) {
    return uriJoin(soa, latest.ecom, 'serviceMethod', id);
};

/**
 * @memberof bunsen.endpoints
 * @param offerId
 * @returns {string}
 */
ends.offer = function (offerId) {
    return uriJoin(soa, latest.ecom, 'offer', offerId);
};

ends.paymentAuthorization = function (id) {
    return uriJoin(soa, latest.ecom, 'paymentAuthorization', id);
};

ends.paymentMethod = function () {
    return uriJoin(soa, latest.ecom, 'paymentMethod');
};

ends.review = function (id) {
    return uriJoin(soa, latest.ecom, 'review', id);
};

ends.refund = function (id) {
    return uriJoin(soa, latest.ecom, 'refund', id);
};

ends.inventoryReview = function (id) {
    return uriJoin(soa, latest.inventoryReviews, 'review', id);
};

ends.designFirmsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'firms');
};

ends.designProjectsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'projects');
};

ends.designFirm = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id);
};

ends.designFirmIndex = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firms', 'index', id);
};

function baseDesignFirm (id, type) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id, type);
};

ends.designFirmBasic = function (id) {
    return baseDesignFirm(id, 'basic');
};

ends.designFirmAddress = function (id) {
    return baseDesignFirm(id, 'address');
};

ends.designFirmArticles = function (id) {
    return baseDesignFirm(id, 'articles');
};

ends.designFirmProject = function (id) {
    return baseDesignFirm(id, 'project');
};

ends.designFirmProjects = function (id) {
    return baseDesignFirm(id, 'projects');
};

ends.designFirmAwards = function (id) {
    return baseDesignFirm(id, 'awards');
};

ends.designFirmEmployees = function (id) {
    return baseDesignFirm(id, 'employees');
};

ends.designFirmMedia = function (id) {
    return baseDesignFirm(id, 'media');
};

ends.designFirmPortfolios = function (id) {
    return baseDesignFirm(id, 'portfolios');
};

ends.designFirmProfile = function (id) {
    return baseDesignFirm(id, 'profile');
};

ends.designFirmWeblinks = function (id) {
    return baseDesignFirm(id, 'weblinks');
};

ends.designFirmInstagram = function (id) {
    return baseDesignFirm(id, 'instagram');
};

ends.designAwards = function () {
    return uriJoin(soa, latest.trade, 'awards');
};

ends.designProject = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'project', id);
};

function baseDesignProject (id, type) {
    return uriJoin(soa, latest.trade, 'design', 'project', id, type);
};

ends.designProjectBasic = function (id) {
    return baseDesignProject(id, 'basic');
};

ends.designProjectAddress = function (id) {
    return baseDesignProject(id, 'address');
};

ends.designProjectProfile = function (id) {
    return baseDesignProject(id, 'profile');
};

ends.designAttributes = function (id) {
    return uriJoin(soa, latest.inventory, 'attribute');
};

ends.tradeAssociations = function () {
    return uriJoin(soa, latest.identityTrade, 'tradeAssociations');
};

ends.sellerTradeAssociations = function (id) {
    return uriJoin(soa, latest.identityTrade, 'seller', id, 'tradeAssociations');
};

ends.invoice = function (id) {
    return uriJoin(soa, latest.ecom, 'invoice', id);
};

ends.disbursement = function (id) {
    return uriJoin(soa, latest.ecom, 'disbursement', id);
};

ends.registerSeller = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', vertical);
};

/**
 * Identity endpoints
 * @memberof bunsen.endpoints
 * @param id
 * @return {string}
 */
ends.seller = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id);
};

ends.sellerTwentyFirstCenturyStatus = function (id) {
    return uriJoin(ends.seller(id), 'twentyFirstCenturyStatus');
};

ends.seller31 = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id);
};

ends.userLogin = function () {
    return uriJoin(soa, latest.identity, 'user', 'login');
};

ends.userRegister = function (email) {
    var uri = uriJoin(soa, latest.identity, 'user');
    if (email) {
        uri += '?' + Qs.stringify({email: email});
    }
    return uri;
};

ends.wallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'user', id, 'wallet');
};

ends.walletPaymentMethod = function (userId) {
    return uriJoin(ends.wallet(userId), 'paymentMethod');
};

ends.vault = function (id) {
    return uriJoin(ends.wallet(id), 'paymentMethod', 'vault');
};

ends.sellerWallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id, 'wallet');
};

ends.sellerVault = function (id) {
    return uriJoin(ends.sellerWallet(id), 'paymentMethod', 'vault');
};

ends.sellerPaymentProfile = function (sellerID) {
    return uriJoin(soa, latest.identityHyperwallet, 'seller', sellerID, 'paymentProfile');
};

ends.report = function () {
    return uriJoin(soa, latest.boss, 'report');
};

//TODO remove after dibs-cms-dealer-storefront goes live
ends.updateDealerStorefrontProfile = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile');
};

ends.storefrontProfile = function (sellerId, storefrontId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile', storefrontId);
};

/**
 * Save a shipmentQuote at the seller level :
 * @param id
 * @returns {*}
 */
ends.sellerQuote = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id, 'shipmentQuotes');
};

ends.sellers = function () {
    return uriJoin(soa, latest.identityShipping, 'sellers');
};

ends.sellerLogin = function () {
    return uriJoin(soa, latest.identity, 'seller', 'login');
};

/**
 * soa/identity/2.1/seller/{vertical_sellerid}/profile
 * @memberof bunsen.endpoints
 * @param id
 * return {string}
 */
ends.sellerProfile = function (id) {
    return uriJoin(soa, latest.identity, 'seller', id, 'profile');
};

ends.billItemsBySeller = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'bill');
};

ends.charges = function () {
    return uriJoin(soa, latest.identity, 'seller', 'charges');
};

ends.charge = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'charge');
};

ends.updateCharge = function (chargeId) {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charge', chargeId);
};

ends.statement = function () {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charges');
};


/**
 * /soa/identity[version]/user/[id]
 * Note: we should always be using the /soa/identity[version]/user/[id] endpoint
 * @memberof bunsen.endpoints
 */
ends.user = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

/**
 * @memberof bunsen.endpoints
 * @param id
 * @returns {string}
 */
ends.buyer = ends.user;

ends.userById = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

ends.users = function () {
    return uriJoin(soa, latest.identity, 'users');
};

ends.userProfile = function (userId) {
    return uriJoin(ends.user(userId), 'profile');
};

ends.userProProfile = function (userId) {
    return uriJoin(ends.user(userId), 'proProfile');
};

ends.userNewsletters = function (userId) {
    return uriJoin(ends.user(userId), 'newsletters');
};

ends.userSourceAttribution = function (userId) {
    return uriJoin(ends.user(userId), 'sourceAttribution');
};

ends.userPassword = function (userId, options) {
    var uri = uriJoin(ends.user(userId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?' + Qs.stringify({email: options.email});
    } else if (options.passwordToken) {
        uri += '?' + Qs.stringify({passwordToken: options.passwordToken});
    }

    return uri;
};

ends.sellerPassword = function (sellerId, options) {
    var uri = uriJoin(ends.seller(sellerId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?email=' + options.email;
    } else if (options.passwordToken) {
        uri += '?passwordToken=' + options.passwordToken;
    }

    return uri;
};

// ------------------
// Logistics - aka Shipping 2
// ------------------
// Logistics - aka Shipping 2
ends.shipmentServiceMethod = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethod');
};

ends.shipmentServiceMethods = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethods');
};

ends.carriersBase = function () {
    return uriJoin(soa, latest.logistics, 'carriers');
};

ends.carrier = function () {
    return uriJoin(soa, latest.logistics, 'carrier');
};

ends.loadTracking = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipment', 'loadTracking');
};

ends.region = function (regionId) {
    return uriJoin(soa, latest.logistics, 'region', regionId);
};

ends.regions = function () {
    return uriJoin(soa, latest.logistics, 'regions');
};

ends.regionsForAddress = function () {
    return uriJoin(soa, latest.logistics, 'regionsForAddress');
};

/**
 * soa/identity/user/me
 * @memberof bunsen.endpoints
 */
ends.userMe = function () {
    return uriJoin(soa, latest.identity, 'user', 'me');
};

/**
 * soa/identity/user/me/profile
 * @memberof bunsen.endpoints
 */
ends.userMeProfile = function () {
    return uriJoin(soa, latest.identity, 'user', 'me', 'profile');
};

/**
 * soa/identity/1/role
 */
ends.roles = function () {
    return uriJoin(soa, latest.identity, 'role');
};

ends.role = function (id) {
    return uriJoin(ends.roles(), id);
};

/**
 * soa/identity/1/permission
 */
ends.permissions = function () {
    return uriJoin(soa, latest.identity, 'permission');
};

ends.permission = function (id) {
    return uriJoin(soa, latest.identity, 'permission', id);
};

ends.category = function (verticalId) {
    return uriJoin(soa, latest.inventoryCategories, 'category', verticalId);
};

ends.categories = function () {
    return uriJoin(soa, latest.inventoryCategories, 'categories');
};

ends.creator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator);
};

ends.creatorById = function (creatorId) {
    return uriJoin(soa, latest.inventoryCreators, creator, creatorId);
};

ends.creatorList = function () {
    return uriJoin(soa, latest.inventoryCreators, 'creators');
};

ends.creatorRoles = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'creatorRoles');
};

ends.getCreators = function () {
    return uriJoin(services, query, 'new_creators_all.dibs');
};

/**
 * Find creators based on some parameters, such as status = Approved, etc.
 */
ends.findCreators = function () {
    return uriJoin(services, query, 'find_creators.dibs');
};

/**
 * Find creators by id
 */
ends.findCreatorsById = function () {
    return uriJoin(services, query, 'creator_by_id.dibs');
};

/**
 * The following 2 endpoints get creators filtering on a string matched against the creator name.
 * Accepts either "starts_with" or "contains" parameters
 */
ends.getCreatorsNonAlphaInitials = function () {
    return uriJoin(services, query, 'creators_non_alpha_initial.dibs');
};

ends.getCreatorsByPhrase = function () {
    return uriJoin(services, query, 'creators_by_phrase.dibs');
};

ends.getCreatorsByPhraseNoCache = function () {
    return uriJoin(services, query, 'creators_by_phrase_woc.dibs');
};

/**
 * Saving an item-creator relationship. Item id with an array of objects with 'creator_id', 'attribution', 'roles' etc.
 */
ends.saveItemCreator = function () {
    return uriJoin(services, form, 'item.saveCreator');
};

/**
 * Saving a creator (name, status, url_tag, has_page) with no relationships, or a new creator
 */
ends.saveCreator = function () {
    return uriJoin(services, 'creatorservice', 'save_creator');
};

// item unknown creator endpoint
ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.inventoryRoot = function () {
    return uriJoin(soa, latest.inventory);
};

ends.changeCreator = function (previousCreator) {
    return uriJoin(soa, latest.inventoryCreators, creator, 'changeCreator', previousCreator);
};

/**
 * /soa/inventory-3/1/dimensionSet/
 * @param {number} [id]
 */
ends.dimensionSets = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'dimensionSet') + (id ? '/' + id : '');
};

ends.materials = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'material') + (id ? '/' + id : '');
};

ends.styles = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'style') + (id ? '/' + id : '');
};

ends.attributesByCategory = function () {
    return uriJoin(soa, latest.inventoryAttributes, 'attribute/category');
};

ends.item = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk);
};

ends.items = function () {
    return uriJoin(soa, latest.inventoryItem, 'item');
};

ends.itemListings = function (pk) {
    return uriJoin(ends.item(pk), 'listings');
};

// IMPORTANT! THIS IS A HACK TO WORK AROUND THE WAY ITEM UPLOAD SAVES LISTINGS. DO NOT USE THIS UNLESS YOU KNOW WHAT
// YOU ARE DOING!!!
ends.cleanUpListingsAfterFailure = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk, 'cleanUpListingsAfterFailure');
};

//netPrice bulk update endpoint
ends.batchPrices = function (batchId) {
    return uriJoin(soa, latest.inventoryItem, 'prices', 'batch') + (batchId ? '/' + batchId : '');
}

/**
 * /soa/inventory/3/item
 * @param pk
 * @memberof bunsen.endpoints
 */
ends.itemWithReviews = function (pk) {
    return uriJoin(soa, latest.inventoryReviews, 'item', pk);
};

ends.itemsWithReviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'items');
};

/**
 * /soa/inventory/3/reviews
 * Retrieve reviews using filter params like itemId, type, status
 * @memberof bunsen.endpoints
 */
ends.reviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'reviews');
};

/**
 * There are no references to this method in .com, bunsen, or v2.  Will leave it here just in case.
 * @deprecated
 */
ends.getServiceMethods = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuote', 'serviceMethod');
};

ends.mailer = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'mailer');
};

ends.itemStorefrontPreferences = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'storefrontPreferences');
};

/**
 * There are no references to this in v2 or bunsen.  Will leave it here just in case
 * @deprecated
 */
ends.saveBulkShipping = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuotes');
};

ends.itemShipmentQuotes = function (itemId) {
    return uriJoin(soa, latest.inventoryLogistics, 'item', itemId, 'shipmentQuotes');
};

ends.solrItems = function () {
    return uriJoin(soa, latest.inventory, 'item');
};

ends.solrItem = function () {
    return uriJoin(soa, latestServices.inventory, '1', 'solr', 'items');
};

ends.release = function () {
    return uriJoin(soa, latest.inventoryCreators, 'release');
};
/**
 * @memberof bunsen.endpoints
 * @param userId
 * @returns {string}
 */
ends.permissionsByUser = function (userId) {
    return uriJoin(ends.user(userId), 'permission');
};

ends.permissionsByRole = function (roleId, permissionId) {
    return uriJoin(ends.roles(), roleId, 'permission', permissionId);
};

ends.clump = function () {
    return uriJoin(soa, form, '1', 'clump');
};

/**
 * @memberof bunsen.endpoints
 * @param template
 * @returns {string}
 */
ends.sendEmailResponsys = function (template) {
    return uriJoin(soa, usercomm, 'email', template);
};
ends.usercommToken = function () {
    return uriJoin(soa, usercomm, 'token');
};
ends.sendEmail = function (template) {
    return uriJoin(soa, latest.usercomm, 'email', template);
};
ends.geography = function () {
    return uriJoin(soa, latest.identity, 'geography');
};

ends.portfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioItem = function (portfolioItemId) {
    return uriJoin(soa, latest.identity, portfolio, 'item', portfolioItemId);
};

ends.portfoliosByUser = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, 'portfolio');
};
ends.portfolios = function () {
    return uriJoin(soa, latest.identity, portfolios);
};
ends.portfoliosByItem = function (itemPk) {
    return uriJoin(soa, latest.identity, portfolios, 'item', itemPk);
};
ends.portfolioItemsByPortfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioAddItem = function (portfolioId, itemPk) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'item', itemPk);
};

ends.portfolioAddItemToDefault = function (userId, itemPk) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio, 'default', 'item', itemPk);
};

ends.portfolioSort = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'reorderItemPage');
};

ends.sharePortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, id, 'share');
};

ends.cmsPortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, cms, id);
};

ends.cartPortfolio = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio);
};

ends.cartPortfolioAddItem = function (itemPk) {
    return uriJoin(soa, latest.identity, 'rootPortfolio', 'CART', 'item', itemPk);
};

ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.userRegionalInfo = function () {
    return uriJoin(soa, latest.identity, 'currency', 'resolve', 'ip');
};

ends.dealerAllContacts = function (vertical, legacyId, type) {
    var url = uriJoin(soa, query, json, 'seller_contacts.dibs');
    url = url + '?id=' + legacyId + '&' + vertical;
    if (type) {
        url = url + '&' + type;
    }
    return url;
};

ends.nydcSoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_sold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.nydcHoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_hold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.toggleNYDC = function (itemPk) {
    return uriJoin(soa, latest.inventoryShipping, 'item', itemPk, 'nydc');
};
ends.toggleNYDCv3 = function (itemPk) {
    return uriJoin(soa, latest.inventoryItem, 'item', itemPk, 'nydc');
};

// Used for count on dealer dashboard. Probably wrong and needs to be
// reassessed when dealer itemlist pages are done through v2
ends.twentiethCenturyCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_twentieth_century_count_v1.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.exhibitionsCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_exhibitions_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.regionMap = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', 'stores', vertical);
};

ends.favSeller = function (userId, urlLabel) {
    var baseUrl = userId ? uriJoin(soa, latest.identity, 'user', userId, 'favSeller') : '';
    var urlParam = urlLabel ? '?urlLabel=' + urlLabel : '';

    return baseUrl + urlParam;
};

ends.favorites = function () {
    return uriJoin(soa, latest.identity, 'user', 'favorites');
};

ends.favorite = function (id) {
    var url = uriJoin(soa, latest.identity, 'user', 'favorite');
    if (id) {
        url = uriJoin(url, id);
    }
    return url;
};

ends.accountManager = function (sellerID) {
    return uriJoin(soa, latest.identity, 'seller', sellerID, 'accountManager');
};

ends.userRelationships = function () {
    return uriJoin(soa, latest.identityTrade, 'userRelationships');
};

//get the current time
ends.currentTime = function () {
    return '/dealers/ajax/current_time';
};

// ------------------
// Saturday Shopper Endpoints
// we may still want this if we can delete cms portfolio based on portfolio id
ends.deleteSaturdayShopper = function () {
    return uriJoin(services, form, 'saturday_shopper.delete');
};

/**
 * Publication Management
 * endpoints
 * @type {{:)}}
 */

ends.publications = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publications');
};

ends.publication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id);
};

ends.makeTestPublication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'process');
};

ends.publicationType = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType', id);
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'workflowStates');
};

/**
 * can be types or subTypes
 * @param type
 */
ends.publicationType = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType');
};
ends.publicationTypes = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationTypes');
};

ends.listings = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings');
};

ends.createFromSearch = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings', 'createFromSearch');
};

ends.singleListing = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id);
};

ends.listingsReorder = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listingsOrder');
};

ends.listingAttach = function (id) {
    return uriJoin(this.singleListing(id), 'publication');
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id, 'workflowStates');
};

ends.promotion = function (id) {
    return uriJoin(soa, latest.ecom, 'promotion', id);
};

ends.promotionRuleAnchor = function (id) {
    return uriJoin(soa, latest.ecomPromotion, 'promotionRule', id, 'anchorListMembers');
};

ends.cms = function (id) {
    return uriJoin(soa, latest.cms, id);
};

ends.conversationsForBuyerAndItemUrl = function (options) {
    return uriJoin(soa, latestServices.messagecenter, '2', 'conversation', 'buyer', options.buyerId, 'item', options.itemId);
};

ends.anchorLists = function () {
    return uriJoin(soa, latest.identityShipping, 'anchorList');
};

ends.anchorList = function (listType, listName) {
    return uriJoin(ends.anchorLists(), listType, listName, 'anchors');
};

// Media service
ends.uploadPhoto = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName);
};

ends.uploadPhotoByUrl = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName, 'url');
};

ends.replacePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'replace');
};

ends.resizePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'resize');
};

ends.processPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'process');
};

ends.addPhotoTag = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'photoTag');
};

ends.editPhotoTag = function (tagId) {
    return uriJoin(soa, latest.media, 'photoTag', tagId);
};

ends.mediaAlbum = function (albumId) {
    return uriJoin(soa, latest.media, 'mediaAlbum', albumId);
};

ends.getPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId);
};

ends.uploadVideo = function () {
    return uriJoin(soa, latest.media, 'video');
}

ends.getVideo = function (id) {
    return uriJoin(soa, latest.media, 'video', id);
}

// Analytics
ends.recommendations = function () {
    return uriJoin(soa, latest.analytics, 'recommendations');
};

ends.trending = function () {
    return uriJoin(soa, latest.analytics, 'trending');
};

ends.bulkAttachListings = function (id) {
    return uriJoin(ends.publication(id), 'process');
};
ends.socialNetworks = function () {
    return uriJoin(soa, latest.identitySocialNetworks, 'socialNetworks');
};

ends.userSocialNetworks = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetworks');
};

ends.addUserSocialNetwork = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetwork');
};

ends.userSocialNetwork = function (id) {
    return uriJoin(soa, latest.identitySocialNetworks, 'userSocialNetwork', id);
};

ends.oauth = function (sellerId) {
    return uriJoin(soa, latest.identityOauth, 'seller', sellerId, 'oauth', 'code');
};

ends.graphQL = function () {
    return uriJoin(soa, 'graphql');
};

ends.inventoryHold = [soa, latest.inventory, 'hold'].join('/');

ends.inventoryHoldById = function (id) {
    return uriJoin(soa, latest.inventory, 'hold', id);
};

ends.latest = latest;
ends.latestServices = latestServices;
ends.soa = soa;
module.exports = ends;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-endpoints/endpoints.js
// module id = 281
// module chunks = 62